/** Ошибки 409 API → поле формы товара. */
export const PRODUCT_FIELD_BY_CODE = {
  product_exists: 'name',
  sku_exists: 'sku',
  uom_locked: 'base_uom',
};
